import { createSelector } from 'reselect'
import lessonTypes from 'helpers/enums/lessonTypes'

const lessonsData = state => state.lessons
const getMediaSlidesData = state => state.mediaSlides
const privateLibraryLessonsData = state => state.libraries.current.lessons

const storeLessonsIdWithoutData = createSelector(
	[ getMediaSlidesData, privateLibraryLessonsData, lessonsData ],
	(mediaSlides, privateLibraryLessons, lessons) => {
		const lessonsIdWithoutData = privateLibraryLessons.filter(lessonUid =>
			lessons[lessonUid].data.type === lessonTypes.VIDEO &&
			mediaSlides.findIndex(mediaSlide => mediaSlide.lessonUid === lessonUid) === -1
		)
		return ({
			lessonsIdWithoutData,
		})
	}
)

export default storeLessonsIdWithoutData
